import { Component, OnInit } from "@angular/core";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { LogInViewModel, LogInViewModelState } from "./log-in.viewmodel";
import { LOG_IN_I18N } from "./log-in.i18n";

type LoginAction =
  | "idle"
  | "pre-login"
  | "post-login"
  | "login"
  | "logout"
  | "navigate";

@Component({
  selector: "app-log-in",
  templateUrl: "./log-in.component.html",
  styleUrls: ["./log-in.component.scss"],
  imports: SHARED_IMPORTS,
  providers: [LogInViewModel],
})
export class LogInComponent implements OnInit {
  logoUrl: string;
  currentHost = "";

  year = new Date().getFullYear();
  readonly vm$;
  readonly loginWithDifferentAccountLabel = LOG_IN_I18N.loginWithDifferentAccount;

  private readonly actionLabelMap: Record<
    Exclude<LoginAction, "idle">,
    string
  > = {
    logout: LOG_IN_I18N.action.logout,
    "pre-login": LOG_IN_I18N.action.preLogin,
    "post-login": LOG_IN_I18N.action.postLogin,
    login: LOG_IN_I18N.action.login,
    navigate: LOG_IN_I18N.action.navigate,
  };

  constructor(private vm: LogInViewModel) {
    this.vm$ = this.vm.vm$;
  }

  ngOnInit() {

    this.vm.init();

    this.currentHost = window.location.hostname;
    this.logoUrl = this.getLogoUrl(this.currentHost);
  }

  // urlからログインページで表示するロゴをmap
  getLogoUrl(currentHostname: string): string {
    const logoMap: Record<string, string> = {
      "app.gokuri.com": "../assets/gokuri_logo_bk.svg",
      "oishien.app.gokuri.com": "../assets/oishien_logo_bk.svg",
      localhost: "../assets/gokuri_logo_bk.svg",
      "efrgaevfbgs.app.gokuri.com": "../assets/oishien_logo_bk.svg",
    };

    return logoMap[currentHostname] || "../assets/gokuri_logo_bk.svg";
  }

  handlePrimaryAction(): void {
    this.vm.handlePrimaryAction(true);
  }

  loginWithDifferentAccount(): void {
    this.vm.loginWithDifferentAccount();
  }

  getPrimaryButtonLabel(state: LogInViewModelState): string {
    if (state.action === "idle") {
      return this.getIdleLabel(state);
    }

    return this.actionLabelMap[state.action] ?? this.getIdleLabel(state);
  }

  private getIdleLabel(state: LogInViewModelState): string {
    if (!state.isAuthenticated || !state.loginUserName) {
      return LOG_IN_I18N.action.preLogin;
    }

    return LOG_IN_I18N.action.loginAs(state.loginUserName);
  }
}
